import React from 'react'
import Navbar from '../inc/Navbar'
import KidsFrock from './KidsFrock'
import {Link}  from "react-router-dom";

function Kidsfrockpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/><br/>
         <div className='nadiacloth'>
                <div className="album py-1">
                  <div className="container mt-4">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Kids Frock</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
        <KidsFrock/>
        <br/>
    </div>
  )
}

export default Kidsfrockpage